import { Fragment, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import classNames from "classnames";

export default function Modal({
  open,
  onClose,
  className,
  children,
  backdropClass,
  transform = true,
  mainClassName,
}) {
  const cancelButtonRef = useRef(null);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-[999]"
        initialFocus={cancelButtonRef}
        onClose={onClose}
      >
        {/* Backdrop */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className={classNames(
              backdropClass,
              "fixed inset-0 z-[998] bg-gray-900/30 backdrop-blur-sm transition-opacity"
            )}
          />
        </Transition.Child>

        {/* Modal wrapper */}
        <div
          className={classNames(
            mainClassName,
            "fixed inset-0 z-[1000] w-screen overflow-y-auto"
          )}
        >
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            {/* Modal panel */}
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={classNames(
                  className,
                  "relative overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all w-full max-w-lg mt-10",
                  { transform }
                )}
              >
                <div className="px-6 py-5">
                  <div className="relative">{children}</div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
